import styled from 'styled-components';

export const CourseActionsWrapper = styled.div`
  display: flex;
  align-items: end;
  justify-content: flex-start;
  gap: 27px;
  width: 100%;
  margin-top: auto;
  color: ${(props) => props.theme.colors.link};

  &.completed {
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .action,
  .action > div {
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    text-transform: uppercase;
  }
  .leave {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 5px;

    svg {
      fill: ${(props) => props.theme.colors.link};
      stroke: ${(props) => props.theme.colors.link};
    }
  }

  .download {
    @media ${(props) => props.theme.device.mobileL} {
      width: 100%;
    }
  }

  .certificate-message {
    color: ${(props) => props.theme.colors.textSecondary};
    margin-top: 12px;
    line-height: 18px;
  }

  .complete-msg-wrapper {
    @media ${(props) => props.theme.device.mobileL} {
      margin-bottom: 24px;
    }
  }

  @media ${(props) => props.theme.device.tabletL} {
    flex-wrap: wrap;
  }

  @media ${(props) => props.theme.device.mobileL} {
    flex-direction: column;
    align-items: start;
    gap: 8px;

    &.in-progress {
      flex-direction: column-reverse;
    }
  }
`;

export const ShowStatusContainer = styled.div`
  width: inherit;
  margin-right: 30px;

  .last-activity {
    margin-bottom: 10px;
    color: ${(props) => props.theme.colors.textPrimary};
    display: flex;
    align-items: center;
    gap: 5px;
    max-width: calc(100% - 40px);

    svg {
      stroke: ${(props) => props.theme.colors.textPrimary};
    }
  }

  @media ${(props) => props.theme.device.mobileL} {
    margin-right: 0;
    margin-bottom: 24px;
  }
`;

export const ProgressBarWrapper = styled.div`
  width: 100%;
  position: relative;

  & .percentage {
    position: absolute;
    top: -35px;
    right: 0;
    font-style: normal;
    font-weight: 300;
    font-size: 20px;
    line-height: 24px;
    color: ${(props) => props.theme.colors.textPrimary};
  }
`;

export const Download = styled.div`
  cursor: pointer;
  margin-left: auto !important;
  margin-right: 0 !important;
  display: flex;
  align-items: center;
  gap: 5px;

  & svg {
    fill: none;
    stroke: ${(props) => props.theme.colors.link};
  }
`;

export const CompletionMsg = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  color: ${(props) => props.theme.colors.successMessage};
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 18px;

  svg {
    fill: none;
    stroke: ${(props) => props.theme.colors.successMessage};
  }
`;
